import { ReactNode } from 'react';
import { ThemeStylesProvider } from '../theme';
import { Provider } from '@/state/store';
import { AudioProvider } from '@/theme/audio';
import AnalyticsProvider from '@/arise/global/analytics';
import Preloader from '@/components/Preloader';
import AutoAuthGate from '@/app/auth/AutoAuthGate';
import RedeemRewardModal from '@/components/RedeemRewardModal';
import AriseDebugMenu from '@/components/AriseDebugMenu';
import DocumentTitle from '@/components/DocumentTitle';

import './globals.scss';

export default function RootLayout({ children }: { children: ReactNode }) {
    return (
        <Provider>
            <Preloader>
                <AutoAuthGate>
                    <DocumentTitle />
                    <AnalyticsProvider />
                    <AudioProvider />
                    <ThemeStylesProvider />
                    {children}
                    <RedeemRewardModal />
                    <AriseDebugMenu />
                </AutoAuthGate>
            </Preloader>
        </Provider>
    );
}
